import { render, staticRenderFns } from "./MultiAreaChange.vue?vue&type=template&id=705d1588&"
import script from "./MultiAreaChange.vue?vue&type=script&lang=js&"
export * from "./MultiAreaChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports